<template>
  <div class="gestion-proveedor-container">
    <v-container fluid>
      <div class="unified-container">
        <!-- Header Moderno -->
        <div class="header-section">
          <div class="title-section">
            <v-icon class="title-icon" color="white">mdi-account-box</v-icon>
            <div class="title-text">
              <h1 class="main-title">PROVEEDORES</h1>
              <p class="subtitle">Gestión de proveedores empresariales</p>
            </div>
          </div>
          <v-dialog
            v-model="dialog"
            max-width="700px"
            persistent
            overlay-color="black"
            overlay-opacity="0.8"
            :z-index="9999"
            attach
          >
            <template v-slot:activator="{ on }">
              <v-btn class="add-btn" v-on="on" elevation="2">
                <v-icon left color="white">mdi-plus</v-icon>
                Agregar Proveedor
              </v-btn>
            </template>
            <v-card class="modal-card">
              <v-card-title class="modal-header">
                <div class="modal-title-content">
                  <v-icon class="modal-icon" color="white">mdi-account</v-icon>
                  <span class="modal-title">{{ formTitle }}</span>
                </div>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.nit"
                        label="Nit"
                        @blur="consultarProveedor"
                        @input="validarNitInput"
                        :rules="nitRules"
                        :error-messages="nitErrorMessages"
                        :loading="isConsulting"
                        hint="Escribe entre 8 y 15 dígitos (se permiten guiones, puntos, espacios, @)"
                        persistent-hint
                        maxlength="15"
                        counter="15"
                      >
                        <template v-slot:append>
                          <v-progress-circular
                            v-if="isConsulting"
                            indeterminate
                            size="20"
                            color="primary"
                          ></v-progress-circular>
                          <v-icon
                            v-else-if="
                              editedItem.nit &&
                              esNitValidoVisual(editedItem.nit)
                            "
                            color="success"
                            small
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.nombre_empresa"
                        label="Nombre Empresa"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.contacto"
                        label="Contacto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.telefono"
                        label="Teléfono"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        v-model="editedItem.nivel"
                        :items="niveles"
                        item-text="text"
                        item-value="value"
                        label="Nivel"
                        outlined
                        dense
                        clearable
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions class="modal-actions">
                <v-spacer></v-spacer>
                <v-btn class="cancel-btn" @click="close">Cancelar</v-btn>
                <v-btn class="save-btn" @click="save">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <!-- Búsqueda -->
        <div class="search-section">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Buscar proveedor..."
            single-line
            class="google-search-field"
            color="#3b82f6"
            solo
            flat
            clearable
            hide-details
          />
        </div>

        <!-- Tabla de Proveedores -->
        <div class="table-section">
          <v-data-table
            :key="keyTable"
            :headers="headers"
            :items="proveedores"
            :search="search"
            :sort-by="['fechaCreacion']"
            :sort-desc="[true]"
            class="modern-table"
            elevation="0"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon class="mr-2" color="success" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>

            <!-- Columna Nivel con chip de color -->
            <template v-slot:[`item.nivel`]="{ item }">
              <v-chip
                :color="item.nivel === 'critico' ? 'error' : 'success'"
                outlined
                small
              >
                {{ item.nivel === 'critico' ? 'CRÍTICO' : 'NO CRÍTICO' }}
              </v-chip>
            </template>

            <template v-slot:no-data>
              <div class="no-data-container">
                <v-icon class="no-data-icon" color="#64748b"
                  >mdi-database-off</v-icon
                >
                <p class="no-data-text">No se encontraron proveedores</p>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        class="modern-snackbar"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";

export default {
  data() {
    return {
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      proveedores: [],
      dialog: false,
      keyTable: 0,

      // Variables para validación
      isConsulting: false,
      nitErrorMessages: [],
      isNitValid: false,

      // Opciones para el select de nivel
      niveles: [
        { text: "Crítico", value: "critico" },
        { text: "No Crítico", value: "no_critico" },
      ],

      // Reglas de validación
      nitRules: [
        (v) => {
          const valor = (v || "").toString();
          if (!valor) return true;
          const digitos = (valor.match(/\d/g) || []).join("");
          return (
            (digitos.length >= 8 && digitos.length <= 15) ||
            "NIT debe tener entre 8 y 15 dígitos numéricos"
          );
        },
      ],
      nombreRules: [(v) => !!v || "Nombre de empresa es requerido"],
      headers: [
        { text: "Nit", value: "nit", align: "center", class: "column" },
        {
          text: "Nombre Empresa",
          value: "nombre_empresa",
          align: "center",
          class: "column",
        },
        {
          text: "Contacto",
          value: "contacto",
          align: "center",
          class: "column",
        },
        {
          text: "Teléfono",
          value: "telefono",
          align: "center",
          class: "column",
        },
        {
          text: "Nivel",
          value: "nivel",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        idProveedor: "",
        nit: "",
        nombre_empresa: "",
        contacto: "",
        telefono: "",
        nivel: "no_critico",
      },
      editedIndex: -1,
      editedItem: {
        idProveedor: "",
        nit: "",
        nombre_empresa: "",
        contacto: "",
        telefono: "",
        nivel: "no_critico",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Proveedor" : "Editar Proveedor";
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
  },

  mounted() {
    this.obtenerProveedor();
  },

  methods: {
    async consultarProveedor() {
      const nit = this.editedItem.nit?.replace(/[^\d\-\.\s@]/g, "");

      if (!nit || nit.length < 8) {
        this.limpiarFormulario();
        this.ocultarMensajeCreacion();
        this.mostrarMensaje("El NIT debe tener al menos 8 dígitos", "warning");
        return;
      }

      if (!this.validarNit(nit)) {
        this.limpiarFormulario();
        this.ocultarMensajeCreacion();
        this.mostrarMensaje(
          "El NIT debe tener entre 8 y 15 dígitos numéricos",
          "error"
        );
        return;
      }

      this.isConsulting = true;

      try {
        const response = await axios.post(
          `${env.endpoint}user/consultarProveedor`,
          {
            nit: nit,
            nombre_empresa: this.editedItem.nombre_empresa,
            contacto: this.editedItem.contacto,
            telefono: this.editedItem.telefono,
          }
        );

        if (response.data.success) {
          this.autocompletarFormulario(response.data.proveedor);
          this.mostrarMensaje("Proveedor encontrado", "success");
        }
      } catch (error) {
        console.error("Error:", error);
        this.mostrarMensaje("Error al consultar proveedor", "error");
      } finally {
        this.isConsulting = false;
      }
    },

    validarNitInput() {
      const nit = this.editedItem.nit?.replace(/[^\d\-\.\s@]/g, "");
      const digitos = nit.replace(/[^\d]/g, "");
      if (digitos.length >= 8 && digitos.length <= 15) {
        this.nitErrorMessages = [];
        this.isNitValid = true;
      } else if (digitos.length > 0 && digitos.length < 8) {
        this.nitErrorMessages = [
          "NIT incompleto - faltan " + (8 - digitos.length) + " dígitos",
        ];
        this.isNitValid = false;
      } else if (digitos.length > 15) {
        this.nitErrorMessages = ["NIT demasiado largo - máximo 15 dígitos"];
        this.isNitValid = false;
      } else {
        this.nitErrorMessages = [];
        this.isNitValid = false;
      }
    },

    validarNit(nit) {
      const nitLimpio = nit.replace(/[^\d\-\.\s@]/g, "");
      const digitos = nitLimpio.replace(/[^\d]/g, "");
      return (
        digitos.length >= 8 &&
        digitos.length <= 15 &&
        /^\d{8,15}$/.test(digitos)
      );
    },

    esNitValidoVisual(valor) {
      const nit = (valor || "").toString().replace(/[^\d\-\.\s@]/g, "");
      const digitos = nit.replace(/[^\d]/g, "");
      return digitos.length >= 8 && digitos.length <= 15;
    },

    autocompletarFormulario(proveedor) {
      this.editedItem.nombre_empresa = proveedor.nombre_empresa || "";
      this.editedItem.contacto = proveedor.contacto || "";
      this.editedItem.telefono = proveedor.telefono || "";
      this.editedItem.nivel = proveedor.nivel || "no_critico";
    },

    limpiarFormulario() {
      this.editedItem.nombre_empresa = "";
      this.editedItem.contacto = "";
      this.editedItem.telefono = "";
    },

    ocultarMensajeCreacion() {},

    mostrarMensaje(mensaje, tipo) {
      this.text = mensaje;
      this.snackbar = true;
      if (tipo === "success") {
        this.snackbarColor = "#4caf50";
      } else if (tipo === "error") {
        this.snackbarColor = "#f44336";
      } else if (tipo === "warning") {
        this.snackbarColor = "#ff9800";
      }
    },

    obtenerProveedor() {
      axios.get(`${env.endpoint}user/todosProveedores`).then((res) => {
        this.proveedores = res.data
          .map((p) => ({
            idProveedor: p.idProveedor,
            idRegistro: p.idRegistro,
            nit: p.nit,
            nombre_empresa: p.nombre_empresa,
            contacto: p.contacto,
            telefono: p.telefono,
            nivel: p.nivel || "no_critico",
            fechaCreacion:
              p.fechaCreacion || p.fecha_creacion || p.created_at || new Date(),
          }))
          .sort((a, b) => {
            const fechaA = new Date(a.fechaCreacion);
            const fechaB = new Date(b.fechaCreacion);
            return fechaB - fechaA;
          });

        this.keyTable++;
      });
    },

    editItem(item) {
      this.editedIndex = this.proveedores.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (!this.editedItem.idProveedor && this.editedItem.idRegistro) {
        this.editedItem.idProveedor = this.editedItem.idRegistro;
      }
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      const formData = new FormData();
      formData.append("idProveedor", this.editedItem.idProveedor);
      formData.append("nit", this.editedItem.nit || "");
      formData.append("nombre_empresa", this.editedItem.nombre_empresa || "");
      formData.append("contacto", this.editedItem.contacto || "");
      formData.append("telefono", this.editedItem.telefono || "");
      formData.append("nivel", this.editedItem.nivel || "no_critico");

      if (this.editedIndex > -1) {
        axios
          .post(`${env.endpoint}user/updateProveedores`, formData)
          .then((res) => {
            console.log("Respuesta actualización:", res.data);
            if (res.data.estado) {
              swal({
                title: "Modificado",
                text: res.data.mensaje,
                icon: "success",
                timer: 2000,
                buttons: ["Cancelar", true],
              });
              this.obtenerProveedor();
            } else {
              swal({
                title: "Error",
                text: res.data.mensaje,
                icon: "error",
                buttons: ["Cancelar", true],
              });
            }
            this.close();
          })
          .catch((err) => {
            console.error("Error en actualización:", err);
            swal({
              title: "Error",
              text: "Error en la solicitud al servidor",
              icon: "error",
              buttons: ["Cancelar", true],
            });
            this.close();
          });
      } else {
        axios
          .post(`${env.endpoint}user/createProveedores`, formData)
          .then((res) => {
            if (res.data.estado === true) {
              swal({
                title: "Registrado",
                text: res.data.mensaje,
                icon: "success",
                timer: 2000,
                buttons: ["Cancelar", true],
              });
              this.obtenerProveedor();
            } else {
              swal({
                title: "Error",
                text: res.data.mensaje,
                icon: "error",
                buttons: ["Cancelar", true],
              });
            }
            this.close();
          });
      }
    },
  },
};
</script>

<style scoped>
/* ===== CONTENEDOR PRINCIPAL ===== */
.gestion-proveedor-container {
  background: transparent;
  min-height: 100vh;
  padding: 0;
}

/* ===== CONTENEDOR UNIFICADO ===== */
.unified-container {
  background: white;
  border-radius: 0;
  box-shadow: none;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 1200px;
}

/* ===== HEADER SECTION ===== */
.header-section {
  margin-bottom: 0;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  border-radius: 0;
  padding: 2rem 3rem;
  box-shadow: none;
  margin: 0;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.title-icon {
  font-size: 1.8rem !important;
}

.title-text {
  color: white;
}

.main-title {
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 0.9rem !important;
  margin: 0.25rem 0 0 0 !important;
  opacity: 0.9;
  font-weight: 400;
}

.add-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 0.6rem 1.25rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
  transition: all 0.3s ease !important;
  font-size: 0.9rem !important;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.5) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  margin-bottom: 0;
  padding: 2rem 2rem 1.5rem 2rem;
  border-bottom: none;
  background: white;
  display: flex;
  justify-content: center;
}

.google-search-field {
  margin: 0 !important;
  max-width: 500px;
  width: 100%;
}

.google-search-field >>> .v-input__control {
  background: white !important;
}

.google-search-field >>> .v-input__slot {
  background: white !important;
  border: 1px solid #dadce0 !important;
  border-radius: 24px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
  min-height: 44px !important;
  padding: 0 16px !important;
}

.google-search-field >>> .v-input__slot:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-color: #dadce0 !important;
}

.google-search-field >>> .v-input__slot:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-color: #3b82f6 !important;
}

.google-search-field >>> .v-input__control .v-input__append-inner {
  margin-right: 8px !important;
}

.google-search-field >>> .v-input__control .v-input__append-inner .v-icon {
  color: #5f6368 !important;
  font-size: 20px !important;
}

.google-search-field >>> .v-text-field__slot input {
  color: #202124 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  padding: 0 8px !important;
}

.google-search-field >>> .v-text-field__slot input::placeholder {
  color: #9aa0a6 !important;
  font-size: 16px !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  margin-bottom: 0;
  padding: 0 2rem 2rem 2rem;
  background: white;
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.table-section > .modern-table {
  width: 100%;
  max-width: 1200px;
}

.modern-table {
  background: white;
}

.modern-table >>> .v-data-table__wrapper {
  overflow-x: scroll !important;
  overflow-y: visible !important;
  max-width: 100%;
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important;
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important;
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important;
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important;
}

/* Para Firefox */
.modern-table >>> .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #64748b #e5e7eb;
}

.modern-table >>> .v-data-table-header {
  background: #f5f5f5 !important;
}

.modern-table >>> .v-data-table-header th {
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.3s ease;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #374151 !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #e5e7eb !important;
}

/* ===== MODAL STYLES ===== */
.modal-card {
  border-radius: 16px !important;
  overflow: hidden;
}

/* Asegurar que el modal esté por encima del sidebar */
.v-dialog {
  z-index: 9999 !important;
}

.v-overlay {
  z-index: 9998 !important;
}

/* Forzar que el modal esté por encima de todo */
.v-dialog__overlay {
  z-index: 9998 !important;
}

/* Estilos globales para asegurar que el modal esté por encima del sidebar */
.v-application .v-dialog {
  z-index: 9999 !important;
}

.v-application .v-overlay {
  z-index: 9998 !important;
}

/* Estilos específicos para el modal cuando está abierto */
.v-dialog--active .v-dialog {
  z-index: 9999 !important;
}

.v-dialog--active .v-overlay {
  z-index: 9998 !important;
}

/* Asegurar que el modal esté por encima del sidebar usando selectores más específicos */
body .v-dialog {
  z-index: 9999 !important;
}

body .v-overlay {
  z-index: 9998 !important;
}

/* Forzar que el overlay cubra todo incluyendo el sidebar */
.v-overlay--active {
  z-index: 9998 !important;
}

.v-overlay--active .v-overlay__content {
  z-index: 9999 !important;
}

/* Estilos globales para forzar que el overlay cubra el sidebar */
.v-overlay {
  z-index: 9998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

.modal-header {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  padding: 1.5rem 2rem !important;
}

.modal-title-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.modal-icon {
  font-size: 1.5rem !important;
}

.modal-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  margin: 0 !important;
}

.modal-actions {
  padding: 1.5rem 2rem !important;
  background: #f8fafc;
}

.cancel-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border-radius: 8px !important;
  margin-right: 1rem !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.save-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

/* ===== NO DATA STYLES ===== */
.no-data-container {
  text-align: center;
  padding: 3rem 2rem;
  color: #64748b;
}

.no-data-icon {
  font-size: 4rem !important;
  margin-bottom: 1rem !important;
  opacity: 0.5;
}

.no-data-text {
  font-size: 1.125rem !important;
  margin: 0 !important;
  font-weight: 500;
}

/* ===== SNACKBAR STYLES ===== */
.modern-snackbar {
  border-radius: 12px !important;
}

/* ===== FORM FIELD STYLES ===== */
.v-text-field--error .v-input__control {
  border-color: #f44336 !important;
}

.v-text-field--success .v-input__control {
  border-color: #4caf50 !important;
}

/* ===== LOADING SPINNER ===== */
.v-progress-circular {
  margin-left: 8px;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .header-section {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .main-title {
    font-size: 1.5rem !important;
  }

  .title-section {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
